import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";

import styles from "./Login.module.css";

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    try {
      const userCredential = await login(email, password);
      const user = userCredential.user;

      // Check email verification if needed
      // if (!user.emailVerified) {
      //   setError("Please verify your email before logging in.");
      //   setLoading(false);
      //   return;
      // }

      // Navigate after successful login
      navigate("/dashboard"); // or wherever you want
    } catch (error: any) {
      console.error("Login error:", error);

      if (error.code) {
        switch (error.code) {
          case "auth/user-not-found":
          case "auth/wrong-password":
          case "auth/invalid-credential":
            setError("Incorrect email or password");
            break;
          case "auth/too-many-requests":
            setError("Too many attempts. Please try again later.");
            break;
          case "auth/user-disabled":
            setError("This account has been disabled.");
            break;
          default:
            setError(error.message || "Login failed");
        }
      } else if (error.message) {
        setError(error.message);
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container w-100 w-md-50 mt-5 mb-5">
      <h2 className="font-sans font-semibold text-2xl">
        Login to your account
      </h2>
      {error && <p className="font-mono text-red-600 text-sm">{error}</p>}

      <form onSubmit={handleLogin} className="mt-4">
        <div>
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            required
          />
        </div>

        <div className="mt-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            required
          />
        </div>

        <button
          type="submit"
          aria-label="Login"
          disabled={loading}
          className={`${styles.primaryButton} btn mt-3 mb-3 text-white w-100`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <div className="mt-2">
          <Link to="/forgot-password">I forgot my password</Link>
        </div>

        <hr className="my-4" />

        <h2 className="mt-5">Don't have an account yet?</h2>
        <p className="mt-3 text-muted">
          Unleash the full potential of your data. Join DataRevival to transform
          information into intelligent insight.
        </p>
        <Link
          className={`${styles.secondaryButton} btn mt-3 mb-3 w-100`}
          to="/signup"
        >
          Sign up
        </Link>
      </form>
    </div>
  );
};

export default Login;
